export default "__VITE_ASSET__2k7YiXQh__";